'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dSingle$002dApp$002dUser from "./presto.types$-Single-App-User.js";
var $p;
/** @constructor */
function $c_Lpresto_types$SingleAppUser$() {
}
export { $c_Lpresto_types$SingleAppUser$ as $c_Lpresto_types$SingleAppUser$ };
$p = $c_Lpresto_types$SingleAppUser$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$SingleAppUser$;
/** @constructor */
function $h_Lpresto_types$SingleAppUser$() {
}
export { $h_Lpresto_types$SingleAppUser$ as $h_Lpresto_types$SingleAppUser$ };
$h_Lpresto_types$SingleAppUser$.prototype = $p;
$p.l = (function() {
  return "SingleAppUser";
});
$p.adL = (function(x$0) {
  return new $j_presto$002etypes$0024$002dSingle$002dApp$002dUser.$c_Lpresto_types$SingleAppUser(x$0.j(0), x$0.j(1), x$0.j(2));
});
var $d_Lpresto_types$SingleAppUser$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$SingleAppUser$, "presto.types$SingleAppUser$", ({
  a1S: 1,
  e: 1,
  g: 1
}));
export { $d_Lpresto_types$SingleAppUser$ as $d_Lpresto_types$SingleAppUser$ };
var $n_Lpresto_types$SingleAppUser$;
function $m_Lpresto_types$SingleAppUser$() {
  if ((!$n_Lpresto_types$SingleAppUser$)) {
    $n_Lpresto_types$SingleAppUser$ = new $c_Lpresto_types$SingleAppUser$();
  }
  return $n_Lpresto_types$SingleAppUser$;
}
export { $m_Lpresto_types$SingleAppUser$ as $m_Lpresto_types$SingleAppUser$ };
//# sourceMappingURL=presto.types$-Single-App-User$.js.map
